import React from "react";
import { Site } from "api/typedefs/Site";
import BibleProvider from "components/Bible/BibleContainer";
import ChapterProvider from "components/Chapter/ChapterContainer";
import ChapterLayout from "components/Chapter/ChapterLayout/ChapterLayout";
import ChapterAudio from "components/Chapter/ChapterAudio/ChapterAudio";
import ChapterMeta from "components/Chapter/ChapterMeta";
import "scripture-styles/dist/css/scripture-styles.css";
import "../../assets/stylesheets/scripture.css";
import { ScriptureHighlightsProvider } from "./ScriptureHighlights";
import { usePageTracker } from "utils/analytics/hooks";
import { BibleDownloadsProvider } from "storage/BibleDownloader/BibleDownloadContext";

const BibleViewer: React.FC<{ site: Site }> = ({ site }) => {
  usePageTracker();

  return (
    <BibleProvider site={site}>
      <BibleDownloadsProvider>
        <ChapterProvider>
          <ScriptureHighlightsProvider>
            <ChapterAudio>
              <ChapterMeta />
              <ChapterLayout />
            </ChapterAudio>
          </ScriptureHighlightsProvider>
        </ChapterProvider>
      </BibleDownloadsProvider>
    </BibleProvider>
  );
};

export default BibleViewer;
